module.exports = __webpack_public_path__ + "img/home.590f3909.jpg";